import Component from '../abstracts/Component';
import NewsletterLogic from '../logics/NewsletterLogic';
import TrackingComponent from '../components/TrackingComponent';

export default class NewsletterContentComponent extends Component {
  get SELECTORS() {
    return {
      input: '[data-email-input]',
      emailWrapper: '[data-email-input-wrapper]',
      moreContainer: '[data-nl-more-container]',
      submitButton: '[data-nl-form-submit]',
      privacyCheckbox: '[data-privacy-checkbox]',
      formContainer: '[data-nl-form-container]',
      form: '[data-nl-form]',
      successContent: '[data-nl-success]',
      moreInputs: '[data-nl-more-inputs]',
      laterButton: '[data-do-it-later]'
    };
  }

  get CLASSES() {
    return {
      hidden: 'hidden',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.input = this.$component.querySelector(this.SELECTORS.input);
    this.emailWrapper = this.$component.querySelector(this.SELECTORS.emailWrapper);
    this.moreContainer = this.$component.querySelector(this.SELECTORS.moreContainer);
    this.moreInputs = this.$component.querySelector(this.SELECTORS.moreInputs);
    this.submitButton = this.$component.querySelector(this.SELECTORS.submitButton);
    this.privacyCheckbox = this.$component.querySelector(this.SELECTORS.privacyCheckbox);
    this.formContainer = this.$component.querySelector(this.SELECTORS.formContainer);
    this.form = this.$component.querySelector(this.SELECTORS.form);
    this.successContent = this.$component.querySelector(this.SELECTORS.successContent);
    this.laterButton = this.$component.querySelector(this.SELECTORS.laterButton);
    this.trackingComponent = new TrackingComponent();
  }

  checkSubmit() {
    // enable form submit button
    if (this.privacyCheckbox && this.submitButton) {
      this.privacyCheckbox.addEventListener('change', () => {
        this.submitButton.disabled = this.privacyCheckbox.checked !== true;
      });
    }
  }

  submitForm(target) {
    const ctx = this;
    // get form data
    const url = target.getAttribute('action');
    const data = new FormData(target);
    // submit form
    const response = this.NewsletterLogic.subscribeNewsletter(url, data);
    response.then(response => {
      return response.text()
    })
      .then((html) => {
        // get resp DOM
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const respForm = doc.querySelector(ctx.SELECTORS.form);
        // check errors
        const hasErrors = ctx.checkFormErrors(respForm);
        if (!hasErrors) {
          ctx.trackingComponent.trackAction('newsletterSubscribe', ctx.submitButton.dataset);
          ctx.showSuccess();
        } else {
          // get new inputs, update existing form
          ctx.updateForm(respForm);
          ctx.submitButton.classList.remove('--loading');
        }
      })
  }

  checkFormErrors(respForm) {
    let hasErrors = false;
    if (respForm != null) {
      hasErrors = (respForm.dataset.hasErrors === 'true');
    }

    return hasErrors;
  }

  updateForm(respForm) {
    if (respForm != null && typeof respForm !== 'undefined') {
      try {
        const respEmail = respForm.querySelector(this.SELECTORS.emailWrapper);
        const respMoreInputs = respForm.querySelector(this.SELECTORS.moreInputs);
        this.emailWrapper.innerHTML = respEmail.innerHTML;
        this.moreInputs.innerHTML = respMoreInputs.innerHTML;
      } catch (e) {
        console.error("Error while returning ko response");
      }
    }
  }

  showSuccess() {
    if (this.successContent && this.formContainer) {
      this.formContainer.classList.add('hidden');
      this.successContent.classList.remove('hidden');
    }
  }

  bindEvents() {
    let ctx = this;
    this.input.addEventListener('focus', () => {
      //show rest of form, bind privacy
      this.moreContainer.classList.remove(this.CLASSES.hidden);
      this.checkSubmit();
    });

    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.submitButton.classList.add('--loading');
      this.submitForm(event.target);
    });

    this.laterButton.addEventListener('click', () => {
      this.$emit(this.$customEvents.NL_POPUP_EVENTS.close);
    });
  }

  render() {
    // loading logics
    this.NewsletterLogic = new NewsletterLogic();
    this.bindEvents();
  }
}
